module.exports = __webpack_public_path__ + "static/media/clock-round.d207ac45.svg";